import { Controller } from "@hotwired/stimulus"

// Opens the Help Scout chat (loaded in layouts/shared/_tracking)
//   <button data-controller="support" data-action="support#open">
export default class extends Controller {
  open(event) {
    if (!window.Beacon) return
    event.preventDefault()
    window.Beacon("open")
  }
}
